import React from 'react';
import { Grid } from '@mui/material';

export const AirdropWrapper = ({
  hideText = false,
}: {
  hideText?: boolean;
}) => {
  return (
    <Grid
      display={'flex'}
      flexWrap={'wrap'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={'16px'}
    >
      {!hideText && (
        <Grid
          md={10}
          sm={12}
          xs={6.5}
          display={'flex'}
          flexWrap={'wrap'}
          alignItems={'center'}
          justifyContent={'center'}
          gap={'16px'}
        >
          <p className="airdropWapperTitle">Airdrop calculations in progress</p>
        </Grid>
      )}
      {!hideText && (
        <Grid
          lg={5.5}
          sm={12}
          xs={7.5}
          display={'flex'}
          flexWrap={'wrap'}
          alignItems={'center'}
          justifyContent={'center'}
          gap={'2px'}
        >
          <p className="airdropWrapperSubtitle">Please stand by...</p>
          <p className="airdropWrapperText">
            (don’t worry about your points, they are continuing to accumulate)
          </p>
        </Grid>
      )}
    </Grid>
  );
};
